var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 490 490",
    style: {
      enableBackground: "new 0 0 490 490"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_31_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "75,32.5 75,162.5 75,199.805 245,297.5 415,199.805 415,162.5 415,32.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FCBF47"
    },
    points: "75,162.5 75,199.805 10,162.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FCBF47"
    },
    points: "480,162.5 415,199.805 415,162.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFD248"
    },
    points: "415,199.805 480,162.5 480,457.5 10,457.5 10,162.5 75,199.805 245,297.5  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#231F20"
    },
    d: "M485.011,153.846c-1.549-0.896-3.279-1.344-5.011-1.344V152.5h-55v-120c0-5.522-4.478-10-10-10H75 c-5.522,0-10,4.478-10,10v120H10v0.002c-1.731,0-3.462,0.447-5.011,1.344C1.901,155.634,0,158.932,0,162.5v295 c0,5.522,4.477,10,10,10h470c5.522,0,10-4.478,10-10v-295C490,158.932,488.099,155.634,485.011,153.846z M442.486,172.5 L425,182.536V172.5H442.486z M405,42.5v151.519l-160,91.948L85,194.018V42.5H405z M65,182.536L47.514,172.5H65V182.536z  M470,447.5H20v-20h425v-20H20V179.769l50.018,28.706l170,97.695c3.084,1.773,6.881,1.773,9.965,0l169.995-97.692L470,179.769 V447.5z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 105,
    y: 62.5,
    style: {
      fill: "#231F20"
    },
    width: 50,
    height: 20
  }), /*#__PURE__*/React.createElement("rect", {
    x: 105,
    y: 112.5,
    style: {
      fill: "#231F20"
    },
    width: 280,
    height: 20
  }), /*#__PURE__*/React.createElement("rect", {
    x: 135,
    y: 152.5,
    style: {
      fill: "#231F20"
    },
    width: 220,
    height: 20
  }), /*#__PURE__*/React.createElement("rect", {
    x: 180,
    y: 192.5,
    style: {
      fill: "#231F20"
    },
    width: 130,
    height: 20
  }), /*#__PURE__*/React.createElement("rect", {
    x: 175,
    y: 62.5,
    style: {
      fill: "#231F20"
    },
    width: 25,
    height: 20
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.ba8a3ef77aa889df70ae90b62eb1e81f.svg";
export { ForwardRef as ReactComponent };